var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.proposal && _vm.title)?_c('p',{staticClass:"uppercase text-xs font-main-bold py-4"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }